import { RANK_SUBRANKS } from "./RANK_SUBRANKS";

// На сколько подуровней ранг `to` выше `from` (`rank_badge`): Аколит 6 → Страж 1 — на один.
export const rankSteps = (from: number, to: number): number => {
  const ordinal = (badge: number) => Math.floor(badge / 10) * RANK_SUBRANKS + (badge % 10);
  return ordinal(to) - ordinal(from);
};
